/* eslint-disable */

import { NewWindowExternalLinkIcon } from '@pmi/dsm-react/dist/components/icons/fa/16';
import { Link } from '@pmi/dsm-react';
import styles from '../HelpGuides.module.scss';
import { HUB_HELPURL } from '../../../constants';
import AdminHelpCenterMenu from './AdminHelpCenterMenu';

export interface HelpGuidesProps {
  isAdminNav: boolean;
}

export default function HelpGuides({ isAdminNav }: HelpGuidesProps) {
  const hubHelpCenterMenu = () => {
    return (
      <div>
        <p className="title">Help Guides</p>
        <p className="desc">
          Visit our help section for guidance and quick solutions.
        </p>
        <div className="d-flex align-items-center justify-content-center mt-md-1 mt-3 links">
          <Link
            label="Learner"
            href={HUB_HELPURL}
            target="_blank"
            className="align-items-center"
            icon={<NewWindowExternalLinkIcon fontSize="sm" />}
            iconAlignment="right"
          />
        </div>
      </div>
    );
  };

  return (
    <div className={`w-100 ${styles.helpGuidesBox}`} id="helpGuides">
      <hr className="d-none d-md-block m-0 my-3" />
      {!isAdminNav ? hubHelpCenterMenu() : <AdminHelpCenterMenu />}
    </div>
  );
}
